import React, { FunctionComponent } from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconInformation: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faInfoCircle} />;

export { BrassIconInformation };
